// extracted by mini-css-extract-plugin
module.exports = {"block":"PanelWidthControllerBlock_block__19UIR","block_invalid":"PanelWidthControllerBlock_block_invalid__31Sj8"};